<template>
    <div style="width: 100%; height: 100%;">
        <div class="custom-container">
            <v-card flat>
                <v-card-title class="headline">
                    Mitarbeitergespräche exportieren
                </v-card-title>
            </v-card>
            <v-card flat>
                <v-card-title>
                    <v-btn outlined @click="download()">Herunterladen <v-icon>mdi-download</v-icon></v-btn>
                </v-card-title>
            </v-card>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: [],
        name: "",
        data: () => ({}),
        computed: {
            currentDate(){
                const now = this.$moment.now();
                return this.$moment(now).format('YYYY-MM-DD');
            }
        },
        methods: {
            ...mapActions({}),
            download(){
                this.axios.get('interviews/export', {
                    responseType: 'blob'
                }).then((response) => {
                    const url = URL.createObjectURL(new Blob([response.data], {
                        type: 'application/vnd.ms-excel'
                    }));
                    const fileName = this.currentDate + '_Mitarbeitergespraeche.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click()
                })
            }

        },
    }
</script>

<style scoped>

</style>